app.controller('teacherAppMessagesCtrl', [
    '$scope', '$interval', '$state', '$stateParams', 'messageService', function ($scope, $interval, $state, $stateParams, messageService) {
    	var vm = this;

		vm.messageService = messageService;

		vm.messages = angular.copy(vm.messageService.messages);
		vm.messageText = "";

    	$scope.$on('messageServiceUpdated', function() {
			console.log("teacherAppMessagesCtrl: sync'd messages with messageService");
			vm.messages = angular.copy(vm.messageService.messages);
    	});

    	vm.sendMessage = function() {
    		if (vm.messageText.length == 0) {
    			return;
    		}

    		var msgObj = {
    			from: "Lærer",
    			timestmap: parseInt((new Date()).getTime() / 1000.0), // current unix timestamp
    			text: vm.messageText
    		};

    		vm.messageService.sendMessage(msgObj).then(function() {
    			vm.messageText = "";
    		}, function() {
    			vm.messageText = "";
    		});
    	}
	}
]);
